import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MainPage from './MainPage';
import Layout from './Layout';
import { useEffect } from "react";
import i18n from "./i18n"; // Импорт i18n

// Компонент-обертка, который будет менять язык на основе URL
const LanguageWrapper = ({ children }) => {
  const { lng } = useParams();

  useEffect(() => {
    const selectedLang = lng === "ru" || lng === "en" ? lng : "az";
    i18n.changeLanguage(selectedLang);
    localStorage.setItem("lng", selectedLang);
  }, [lng]);

  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/:lng" element={
          <LanguageWrapper>
            <Layout />
          </LanguageWrapper>
        }>
          <Route index element={<MainPage />} />
        </Route>
        <Route path="*" element={<h1>404 - Səhifə tapılmadı</h1>} />
      </Routes>
      <Footer />
    </Router>
  </React.StrictMode>
);
